import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { AppCtxComponent } from 'js/reactAppCtx';
import OwnershipLovViewModel from 'viewmodel/OwnershipLovViewModel';
import { registerDynImportEntry } from 'js/moduleLoader';

registerDynImportEntry('image/cmdSearch16.svg', () => import('image/cmdSearch16.svg'));
registerDynImportEntry('image/miscSortedDescending10.svg', () => import('image/miscSortedDescending10.svg'));

export default class DesOwnershipLov extends HTMLElement {

    constructor() {
        super();
    }

    static get observedAttributes() {
        return ['accsessionid', 'acc-session-id', 'locale'];
    }

    get accsessionid() {
        return this.getAttribute('acc-session-id') || this.getAttribute('accsessionid');
    }

    connectedCallback() {
        this.classList.add('afx-content-background');
        this.createReactElement();
    }

    attributeChangedCallback(name, oldValue, newValue) {
        ReactDOM.unmountComponentAtNode(this);
        this.createReactElement();
    }

    createReactElement() {
        ReactDOM.render(
            <AppCtxComponent>
                {React.createElement(
                    OwnershipLovViewModel,
                    {
                        accsessionid: this.accsessionid,
                        locale: this.locale
                    },
                    React.createElement('slot')
                )}
            </AppCtxComponent>,
            this);
    }

    disconnectedCallback() {
        ReactDOM.unmountComponentAtNode(this);
    }
}

if (!window.customElements.get('des-ownership-lov')) {
    window.customElements.define(
        'des-ownership-lov',
        DesOwnershipLov
    );
}
